/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLineUp: {
  name: 'line-up';
  data: string;
} = {
  name: 'line-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.646 12.354a.5.5 0 0 0 .708 0L6 7.707l2.646 2.647a.5.5 0 0 0 .708 0L14.5 5.207V8a.5.5 0 0 0 1 0V4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h2.793L9 9.293 6.354 6.646a.5.5 0 0 0-.708 0l-5 5a.5.5 0 0 0 0 .708Z" fill="currentColor"/></svg>`,
};
